<template>
	<div id="page">
		<taskTypeStep-modal v-if="showStepModal" @close="showStepModal = false" :taskTypeStep="selectedStep" @saveStep="saveStepChanges"></taskTypeStep-modal>

		<div class="page-content">
			<div class="page-title page-title-small">
				<h2>
					<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت {{lableText('TaskType')??'نوع وظیفه'}}
					<button data-menu="HelpMenu" class="position-static"><i class="fa fa-question-circle helpIco"></i></button>
				</h2>
				<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
				<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
			</div>
			<div class="card header-card shape-rounded" data-card-height="100">
				<div class="card-overlay bg-highlight opacity-95"></div>
				<div class="card-overlay dark-mode-tint"></div>
			</div>
			<div class="card card-style">
				<div class="content mb-0">
					<div class="input-style input-style-2 has-icon input-required mb-3">
						<i class="input-icon fa fa-check brand-color"></i>
						<span class="color-highlight" :class="{'input-style-1-active' : taskTypeModel.title!==null}">عنوان</span>
						<input class="form-control" type="text" @change="saveHeader" v-model="taskTypeModel.title" @input="v$.taskTypeModel.title.$touch()" :class="{invalid:v$.taskTypeModel.title.$error}">
						<p class="text-danger" v-if="v$.taskTypeModel.title.required.$invalid && v$.taskTypeModel.title.$dirty">لطفا عنوان را وارد کنید.</p>
					</div>

					<div class="mb-3">
						<v-select v-if="OrgJobList!=[]" dir="rtl" label="title" placeholder="پست سازمانی مرتبط" :filterable="false" :searchable="false" multiple chips :options="OrgJobList" :reduce="x=>x.orgJobId" v-model="taskTypeModel.orgJobId" :on-change="saveHeader()">
							<template slot="option">
								<div class="d-center">
									{{ option.title }}
								</div>
							</template>
						</v-select>
						<p class="text-danger" v-if="v$.taskTypeModel.orgJobId.required.$invalid && v$.taskTypeModel.orgJobId.$dirty">لطفا پست سازمانی مرتبط را وارد کنید.</p>
					</div>

					<div class="mb-4">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex align-items-center">
								<i class="fa fa-clock pl-2 brand-color"></i>
								<label class="mb-0 font-12 font-weight-bold">زمان پیشنهادی</label>
							</div>
							<div class="d-flex flex-column">
								<div class="d-flex justify-content-between align-items-center">
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">دقیقه</label>
									<span class="font-13 font-weight-bold px-3"></span>
									<label class="mb-0 font-12 font-weight-bold w-50 text-center">ساعت</label>
								</div>
								<div class="ltr">
									<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskTypeModel.suggestWorkTimeHour" @change="saveHeader" @input="v$.taskTypeModel.suggestWorkTimeHour.$touch()" :class="{invalid:v$.taskTypeModel.suggestWorkTimeHour.$error}">
									<span class="font-13 font-weight-bold px-2">:</span>
									<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskTypeModel.suggestWorkTimeMinute" @change="saveHeader" @input="() => { if(taskTypeModel.suggestWorkTimeMinute  > 59 || taskTypeModel.suggestWorkTimeMinute < 0) { taskTypeModel.suggestWorkTimeMinute = ''}}" maxlength="2" :class="{invalid:v$.taskTypeModel.suggestWorkTimeMinute.$error}">
								</div>
							</div>
						</div>
						<p class="text-danger mt-2" v-if="v$.taskTypeModel.suggestWorkTimeHour.between.$invalid && v$.taskTypeModel.suggestWorkTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
						<p class="text-danger mt-2" v-if="v$.taskTypeModel.suggestWorkTimeMinute.between.$invalid && v$.taskTypeModel.suggestWorkTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>

					</div>

					<div class="mb-4">
						<div class="d-flex justify-content-between align-items-center">
							<div class="d-flex align-items-center">
								<i class="fa fa-clock pl-2 brand-color"></i>
								<label class="mb-0 font-12 font-weight-bold">فرصت زمانی</label>
							</div>
							<div class="ltr">
								<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskTypeModel.workTimeHour" @change="saveHeader" @input="v$.taskTypeModel.workTimeHour.$touch()" :class="{invalid:v$.taskTypeModel.workTimeHour.$error}">
								<span class="font-13 font-weight-bold px-2">:</span>
								<input placeholder="00" class="form-control ltr d-inline-block text-center" style="max-width:60px" type="tel" v-model="taskTypeModel.workTimeMinute" @change="saveHeader" @input="() => { if(taskTypeModel.workTimeMinute  > 59 || taskTypeModel.workTimeMinute < 0) { taskTypeModel.workTimeMinute = ''}}" maxlength="2" :class="{invalid:v$.taskTypeModel.workTimeMinute.$error}">
							</div>
						</div>
						<p class="text-danger mt-2" v-if="v$.taskTypeModel.workTimeHour.between.$invalid && v$.taskTypeModel.workTimeHour.$dirty">ساعت باید مقداری از ۰ تا ۱۰۰۰ داشته باشد.</p>
						<p class="text-danger mt-2" v-if="v$.taskTypeModel.workTimeMinute.between.$invalid && v$.taskTypeModel.workTimeMinute.$dirty">دقیقه باید مقداری از ۰ تا ۵۹ داشته باشد.</p>


					</div>

					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="onHoliDay-checkbox" type="checkbox" v-model="taskTypeModel.onHoliDay" @change="saveHeader">
							<label class="custom-control-label" for="onHoliDay-checkbox"></label>
						</div>
						<span class="mr-5">ارسال در روزهای تعطیل</span>

						<!--<input class="medium-checkbox" id="onHoliDay-checkbox" type="checkbox" v-model="taskTypeModel.onHoliDay" @change="saveHeader">
						<label for="onHoliDay-checkbox">ارسال در روزهای تعطیل</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="onDayAfterHoliDay-checkbox" type="checkbox" v-model="taskTypeModel.onDayAfterHoliDay" @change="saveHeader">
							<label class="custom-control-label" for="onDayAfterHoliDay-checkbox"></label>
						</div>
						<span class="mr-5">ارسال در فردای روز تعطیل</span>

						<!--<input class="medium-checkbox" id="onDayAfterHoliDay-checkbox" type="checkbox" v-model="taskTypeModel.onDayAfterHoliDay" @change="saveHeader">
						<label for="onDayAfterHoliDay-checkbox">ارسال در فردای روز تعطیل</label>-->
					</div>
					<div class="d-flex align-items-center pr-3 mb-3">
						<div class="custom-control ios-switch" style="zoom:85%">
							<input class="ios-input" id="checkTitle-checkbox" type="checkbox" v-model="taskTypeModel.checkTitle" @change="saveHeader">
							<label class="custom-control-label" for="checkTitle-checkbox"></label>
						</div>
						<span class="mr-5">هشدار عنوان تکراری</span>

						<!--<input class="medium-checkbox" id="checkTitle-checkbox" type="checkbox" v-model="taskTypeModel.checkTitle" @change="saveHeader">
						<label for="checkTitle-checkbox">هشدار عنوان تکراری </label>-->
					</div>


					<div class="row px-2 mb-3">

						<div class="col-12 px-2">
							<button :disabled="saveLoading" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm text-uppercase font-900 w-100" @click.prevent="addNewStep()">
								<i class="fa fa-plus font-14"></i>
								افزودن مرحله
							</button>
						</div>
					</div>



					<!--<div class="card card-style mx-0 mb-3">
						<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
							<a class="pr-1" data-toggle="collapse" href="#collapse-description">
								<i class="fa fa-edit mt-2"></i>
								<span>توضیحات</span>
								<i class="fa fa-angle-down"></i>
							</a>
						</div>
						<div class="collapse collapse-reminderCalendars" id="collapse-description">
							<textarea v-model="taskTypeModel.description" class="form-control line-height-m text-justify" rows="3" style="height:200px"></textarea>

						</div>
					</div>-->
					<!--<button type="button" :disabled="Loading || attInProgress" class="btn btn-xxs mt-2 mb-4 btn-full bg-green1-dark rounded-sm font-900 w-100" @click.prevent="CreateTaskType">
						<i class="fa fa-check font-10 ml-2"></i>
						ثبت
					</button>-->


				</div>

			</div>
			<div class="card mt-0 mb-n4 content pt-3 pb-5 shadow-l mx-0">
				<div class="card-body">
					<h2 class="color-white">لیست مراحل انجام کار</h2>
				</div>
				<div class="card-overlay bg-highlight opacity-95 shadow-l"></div>
				<div class="card-overlay dark-mode-tint shadow-l"></div>
			</div>
			<div class="card card-style mt-n5 z-index2">
				<div class="content mb-0 mt-0">
					<draggable v-model="taskTypeModel.taskTypeStepList" item-key="taskTypeStepId" @change="sortSteps" handle=".btn-drag">
						<template #item="{element}">
							<div class="d-flex justify-content-between align-items-center checkLList-list">
								<div class="btn-drag" style="width:6%">
									<i class="fa fa-grip-vertical"></i>
								</div>
								<div class="d-flex align-items-center" style="width:70%">
									<div class="mr-3 py-2 d-flex align-items-start flex-column justify-content-center">
										<del v-if="element.passed===true" class="text-muted">{{element.title}}</del>
										<span v-else class="font-weight-bold">{{element.title}}</span>

									</div>
								</div>
								<div>
									<div class="badge bg-blue2-light mt-0 px-2 py-2" @click="setEditing(element)"><b class="fa fa-edit"></b></div>
									<div class="badge bg-red2-dark mt-0 px-2 py-2 mr-1" @click="removeStep(element)"><b class="fa fa-trash"></b></div>
								</div>
							</div>

						</template>
					</draggable>

				</div>
			</div>


		</div>



		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">

			</div>
		</transition>

		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
			</div>
		</transition>
		<Help-Menu :title="pageTitle" keyEn="TaskList"></Help-Menu>
		<!--<div id="taskTypeHelp" class="menu menu-box-right bg-gray" data-menu-width="100%" data-menu-effect="menu-over">
			<div class="position-relative">
				<button @click="pauseAllVid()" class="close-menu"><i class="fa fa-times text-white font-26"></i></button>
				<div class="card" data-card-height="90">
					<div class="card-top">
						<div class="page-title page-title-small">
							<h2 class="text-center">راهنمای نوع وظیفه</h2>
						</div>
					</div>
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
					<div class="card-bg bg-20"></div>
				</div>
				<div class="card card-style">
					<div class="content mt-0 pb-2">
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-0" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa font-14 fa-info-circle color-magenta1-light"></i>
								<span class="font-14">معرفی موبایل اپلیکیشن تسکینو <span class="badge bg-red2-light mt-0 px-2 py-2 mr-2 position-static">مهم</span></span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-0" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video0" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskType.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/Taskino-mobile-app-intro-TaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
						<div class="list-group list-custom-small list-icon-0 mt-3 border-b">
							<div data-toggle="collapse" href="#collapse-1" class="collapsed list-group-div" aria-expanded="false">
								<i class="fa fa-check-circle color-blue2-dark font-14"></i>
								<span class="font-14">راهنمای نوع وظیفه</span>
								<i class="fa fa-angle-down line-height-xl"></i>
							</div>
						</div>
						<div class="collapse border-b pb-3" id="collapse-1" style="">
							<div class="d-flex justify-content-center">
								<video class="responsive-video" controls id="video1" preload="none" poster="/assets/images/taskAppHelpVideoPoster.jpg">
									<source src="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" type="video/mp4">
								</video>
							</div>
							<a href="https://dssnovinit.com/Content/Upload/Video/tskMobileAppHelp/CreateTaskType.mp4" download target="_blank" class="btn btn-m btn-full bg-highlight rounded-m font-900 mt-3 mx-3">دانلود</a>
						</div>
					</div>
				</div>
			</div>
		</div>-->

	</div>
</template>
<script>
	import useVuelidate from '@vuelidate/core'
	import {
		required, between
	} from "@vuelidate/validators";
	import 'vue-select/dist/vue-select.css';
	import { maska } from 'maska'
	import stepModal from './StepModal.vue'
	import draggable from 'vuedraggable'
	import VueSimpleAlert from 'vue3-simple-alert';
	import HelpMenu from '../Components/HelpMenu.vue';
	export default {
		components: {
			"taskTypeStep-modal": stepModal,
			"Help-Menu": HelpMenu,
			draggable,
		},
		setup: () => ({ v$: useVuelidate() }),
		data() {
			return {
				pageTitle: "",
				attInProgress: false,
				modified: false,
				pageLoaded: false,
				saveLoading: false,
				showStepModal: false,
				selectedStep: null,
				taskTypeModel: {
					code: "",
					title: null,
					taskTypeId: 0,
					userId: 0,
					strorgJobId: "",
					orgJobId: [],
					taskTypeStepList: [],
					suggestWorkTime: null,
					suggestWorkTimeHour: null,
					suggestWorkTimeMinute: null,
					workTime: null,
					workTimeHour: "",
					workTimeMinute: "",
					onHoliDay: false,
					onDayAfterHoliDay: false,
					checkTitle: false
				},
				taskTypeStepModel: {
					seq: 0,
					title: null,
					edited: false,
					editing: false,
					taskTypeId: 0,
					taskTypeStepId: 0,
					taskTypeTitle: null,
					taskTypeorgJobId: []
				},

			};
		},
		computed: {
			Loading() {
				return this.$store.getters.GetLoading;
			},
			propsToWatch() {
				return `${this.taskTypeModel.title}|${this.taskTypeModel.description}`;
			},
			OrgJobList() {
				return this.$store.getters.GetOrgJobList;
			},

		},

		created() {
			this.pageTitle = "راهنمای " + (this.lableText('TaskType') ?? 'نوع وظیفه');
			this.GetOrgJobList();
			if (this.$route.params.taskTypeId != null && this.$route.params.taskTypeId != 0) {
				this.GetTaskTypeItem(this.$route.params.taskTypeId);
			}

		},


		methods: {
			GetOrgJobList() {
				this.$store.dispatch("GetOrgJobListFromServer");
			},
			addNewStep() {
				var obj = {
					title: null,
					edited: false,
					editing: true,
					taskTypeStepId: 0,
					seq: this.taskTypeModel.taskTypeStepList.length + 1
				};
				console.log(this.taskTypeModel.taskTypeStepList);

				this.selectedStep = obj;

				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false

					this.showStepModal = true;
				}
			},
			saveStepChanges(c) {
				this.saveLoading = true;
				c.taskTypeTitle = this.taskTypeModel.title;
				c.taskTypeorgJobId = this.taskTypeModel.orgJobId;
				c.taskTypeId = this.taskTypeModel.taskTypeId;
				this.$http.post("Task/SaveStep", c)
					.then(data => {
						if (isNaN(data.data)) {
							this.showMessage(data.data);
							this.saveLoading = false;
						}
						else {
							this.showSuccessMessage("با موفقیت ذخیره شد.");
							this.showStepModal = false;
							this.GetTaskTypeItem(data.data);
							this.saveLoading = false;
						}
						this.saveLoading = false;
					});

			},
			showAddButton() {
				this.pageLoaded = true;
				var x = screen.height;
				var topForAddButton = x - 220 + 'px';
				this.$refs.addBtn.style.top = topForAddButton;
			},
			GetTaskTypeItem(id) {
				this.$http.get("Task/GetTaskTypeItem?id=" + id)
					.then(data => {
						console.log(data.data);
						this.taskTypeModel = data.data;
						this.taskTypeModel.taskTypeStepList = data.data.taskTypeStepList;
						this.modified = false

					});
			},
			setEditing(c) {

				c.editing = true;

				this.selectedStep = c;
				this.showStepModal = true;

			},
			removeStep(c) {
				VueSimpleAlert.confirm("آیا مایل به حذف این مورد هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					c.title = null;
					this.saveStepChanges(c);
				});
			},
			setShowStepModal() {
				this.showStepModal = true;
			},

			saveHeader() {
				this.v$.$touch(); //it will validate all fields
				if (!this.v$.$invalid) { //invalid, becomes true when a validations return false
					this.$http.post('Task/TaskTypeCreate', this.taskTypeModel).then(response => {
						console.log(response);
						if (response.status == 400 || response.data.success == false) {
							this.$store.dispatch("SetLoading", false);
							var res = response.data.errors.map(a => a.errorMessage);
							this.showErrorMessage(res.join('\n'));
						}
						else {
							this.$store.dispatch("SetLoading", false);
							this.showSuccessMessage("با موفقیت ثبت شد.");
							this.taskTypeModel.taskTypeId = parseInt(response.data.result);
						}

					}, error => {
						this.showErrorMessage("خطا در ارسال اطلاعات");
						this.$store.dispatch("SetLoading", false);
						console.log(error);
					});
				}


			},

			pauseVid(id) {
				console.log(id);
				if (id != null) {
					console.log("pause");
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
			sortSteps() {
				this.$http.post("Task/SortSteps", this.taskTypeModel)
					.then(response => {
						this.saveLoading = false;
						console.log(response);
					})
			}
		},
		mounted() {
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
			this.showAddButton();
		},
		validations: {
			taskTypeModel: {
				title: {
					required,
				},
				orgJobId: {
					required
				},
				suggestWorkTimeHour: {
					between: between(0, 1000)
				},
				workTimeHour: {
					between: between(0, 1000)
				},
				suggestWorkTimeMinute: {
					between: between(0, 59)
				},
				workTimeMinute: {
					between: between(0, 59)
				}
			},
		},
		directives: { maska },
	};
</script>

<style>
	.draggable-container {
		position: absolute;
		z-index: 9;
	}

	.draggable-header {
		z-index: 10;
	}
</style>
